<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" xs="12" class="pa-0">
      <TableSupport ref="table" :show-title="true"></TableSupport>
    </v-col>
  </v-row>
</template>

<script>
// import Vue from 'vue'
// import DialogLinkCompany from './dialogs/DialogLinkCompany'
import TableSupport from "../tables/TableSupport";

export default {
  name: 'Support',
  components: {TableSupport},
  data() {
    return {}
  },
  methods: {
    sendEmail: function () {
      this.$refs.table.sendEmail()
    },
    reload: function () {
      this.$refs.table.reload()
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
